<div *ngIf="IsContentPage" class="height-100per">
  <div *ngIf="outcome && !title.includes('XBRL') && !title.includes('GAAP Taxonomy')">

    <div class="ptb-archive" [ngClass]="PendingContentPage ? 'highlightSearchTerm_PCS': ''" *ngIf="PendingContentPage" >
      <div class="flex-display">
        <div class="cursor-pointer">
          <img src="../../../../assets/icons/Pending.svg" class="pending-image" alt="alarm">
        </div>
        <div class="PendingContent-general-header" tabindex="0">
          {{sectionHeader}}
        </div>
        <div class="text-align-right singleLine">
          <div class="cursor-pointer ">
            <span (click)="EditPCS()" (keyup.enter)="EditPCS()" tabindex="0">
              <a class="anchor-black">{{pc_Edit}}</a>
              <img src="../../../../assets/icons/pencil.svg" class="pencil-iconwidth ml-1px underline" alt="alarm">
            </span>
            <span class="ml-2" (click)="ResetPCS()" (keyup.enter)="ResetPCS()" tabindex="0"> <a class="anchor-black">{{pc_reset}}</a></span>
          </div>
        </div>
      </div>
      <div class="ml-2 flex-display">
        <div class="archive-btn" tabindex="0">
          <span class="archive-Info mr-14px">{{showingContent_Label}} {{FiscalDate}}</span>
          <span class="archive-Info mr-14px">{{fillingStatus_Label}}:{{fillingStatus}}</span>
          <span class="archive-Info mr-14px">{{periodTypeLabel}}: {{PeriodType}}</span>

        </div>
      </div>
    </div>
    <div class="height-100per">
    <div class="padding-content-screen ">
      <div class="flex-display  ml-72 mt-1"[ngClass]="PendingContentPage && hasActualContent? 'mb-1':''">
        <div class="ml-1">
          <img src="../../../../assets/icons/Archive.svg" class="whatsNew-image image-info" alt="Archive">
        </div>
        <div class="h-20px highlight-blue border-bottom-help cursor-pointer" (click)="OpenArchive()" (keyup.enter)="OpenArchive()" tabindex="0">
          Archive
        </div>
        <div class="ml-1">
          <img src="../../../../assets/icons/Link.svg" class="whatsNew-image image-info" alt="Archive">
        </div>
        <div class="h-20px highlight-blue border-bottom-help cursor-pointer" (click)="OpenWhatLinksHere()" (keyup.enter)="OpenWhatLinksHere()" tabindex="0">
          What Links Here
        </div>
      </div>
      <div *ngIf="hasActualContent && (!title.includes('GAAP Taxonomy')) && (!title.includes('XBRL'))">
        <div class="componentHeader mb-2">
          <div><app-breadcrumbs-path [crumbData]="crumbData"></app-breadcrumbs-path></div>
          <div class="flex-display" tabindex="0">
            <div class="float-L history-heading flex-display">
              <div>
                <h1 id="pageHeading" role="heading" class="generalHeader" [innerHTML]="pageHeading">
                </h1>
              </div>
            </div>

          </div>
        </div>
        <div *ngIf="paragraphTitleContent.length == 0">
          <div *ngFor="let info of topicBodyContent">
            <div class="componentHeader mb-2 print-all-content">
              <div class="flex-display mb-24px mt-40px info-box info-box-width">
                <div class="ml-12"><img src="../../../assets/icons/Info..svg" class="info-img" alt="topic info"></div>
                <label class="ml-8 para-content content-blue flex-display" tabindex="0">
                  <span> <span class="bold" [innerHTML]="info.contentPageTitle"></span><span *ngIf="info.contentPageTitle!='' || info.contentPageTitle!=null">:</span><span class="generalNote" (click)="openLinkById($event)" (contextmenu)="onRightClick($event)" (mouseover)="mouseOverFunctions($event)" [innerHTML]="info.contentPageBody|safeContentHTML"></span></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div *ngFor="let para of paragraphTitleContent; let index = index"
             [ngClass]="index+1==paragraphTitleContent.length?'':'mb-1'">
          <div *ngFor="let info of topicBodyContent">
            <div class="componentHeader mb-2 print-all-content" *ngIf="index == info.pageInfoPosition">
              <div class="flex-display mb-24px mt-40px info-box info-box-width">
                <div class="ml-12"><img src="../../../assets/icons/Info..svg" class="info-img" alt="topic info"></div>
                <label class="ml-8 para-content content-blue flex-display" tabindex="0">
                  <span> <span class="bold" [innerHTML]="info.contentPageTitle"></span><span *ngIf="info.contentPageTitle!='' || info.contentPageTitle!=null">:</span><span class="generalNote" (click)="openLinkById($event)" (contextmenu)="onRightClick($event)" (mouseover)="mouseOverFunctions($event)" [innerHTML]="info.contentPageBody|safeContentHTML"></span></span>
                </label>
              </div>
            </div>
          </div>
          <div class="componentHeader flex-display topicBody print-all-content" *ngIf="para.headingName.topicTitleName != ''">
            <div class="width-75" tabindex="0" [id]="para.headingName.topicTitleId">
              <h2 class="paraHeader">
                <span [innerHTML]="para.headingName.topicTitleName"></span>
              </h2>
            </div>
            <div class="mt-0-5rem" *ngIf='showProposedASU && para.headingName == paragraphTitleContent[0].headingName'>
              <div class="float-R">
                <img src="../../../../assets/icons/Related.svg" class="whatsNew-image image-info" alt="Archive">
                <span class="highlight-blue border-bottom-help cursor-pointer singleLine" (click)="OpenRelatedContent()" (keyup.enter)="OpenRelatedContent()" tabindex="0">Related Proposed ASUs </span>
              </div>
            </div>
          </div>
          <div class="componentHeader" *ngFor="let paragraph of para.paragraphContent">
            <div class="componentHeaderPrint print-all-content">
              <div *ngIf="paragraph.paragroup != ''" class="width-90">
                <div class="mt_1 mb-1" tabindex="0">
                  <h3 class="annotation-content-title topicBody">
                    <span>>&nbsp;</span><span [innerHTML]="paragraph.paragroup"></span>
                  </h3>
                </div>
              </div>
            </div>
            <pub-dita-content [id]="paragraph.id" [dita]="paragraph.paraContent" [paraTitle]="paragraph.paraTitle" [annotationCount]="annotationCountNormal[paragraph.id]" [bookmarkCount]="bookmarkCountNormal[paragraph.id]" printqueueAdd="false" [actionLabel]="menuListItems" [archivePage]="archivePage" [paraNum]="paragraph.paraNum" [PendingContentMerge]="PendingContentMergeList" [UserInfo]="loggedInUserInfo" [pageNums]="pageNumsForCount" [s3ImageBasePath]="s3ImageBasePath" [crossreferencestandardType]="crossreferencestandardType" [crossreferencestandardNumber]="crossreferencestandardNumber" [crossreferenceparagraphNumber]="crossreferenceparagraphNumber" [crossReferencedContentID]="crossreferencedParaID" [BreadcrumbPath]="breadcrumbPath" [topic_subtopicNum]="topic_subtopicNum" [pageurl]="pageurl"></pub-dita-content>
          </div>
        </div>
        <div *ngIf="!hasSecContent || !ShowSecContent" class="pb-4rem"></div>
      </div>
    </div>
    <div id="SecContentStarted" *ngIf="hasSecContent && ShowSecContent" [ngClass]="!hasActualContent? '':'pb-'">
      <app-sec-page-viewer [ContentPath]="secUrl" [UserInfo]="loggedInUserInfo" [hasActualContent]="hasActualContent" [s3ImageBasePath]="s3ImageBasePath" [crumbData]="crumbData" [menuListItems]="menuListItems" [PendingContentMerge]="PendingContentMergeList" [PendingContentPage]="PendingContentPage" [crossreferencestandardType]="crossreferencestandardType" [crossreferencestandardNumber]="crossreferencestandardNumber" [crossreferenceparagraphNumber]="crossreferenceparagraphNumber" [crossReferencedContentID]="crossreferencedParaID" [paragraphTitleContentSec]="paragraphTitleContentSec" [topicBodyContentSec]="topicBodyContentSec" [pageHeadingSec]="pageHeadingSec" [outcomeSec]="outcomeSec" [topic_subtopicNum]="topic_subtopicNum" [annotationCount]="annotationCountSec" [bookmarkCount]="bookmarkCountSec" [pageurl]="pageurl"></app-sec-page-viewer>
    </div>
  </div>
  </div>
  <div *ngIf="outcomeXBRL && (title.includes('GAAP Taxonomy') || title.includes('XBRL'))" class="height-100per">
    <app-xbrl-content [crumbData]="crumbData" [hasSecContent]="hasSecContent" [ShowSecContent]="ShowSecContent" isShowAllInOne="false" [ContentPath]="secContent" [pageNums]="pageNumsForCount" [topicBodyContent]="topicBodyContent" [topicBodyContentSec]="topicBodyContentSec" [header]="title" [UserInfo]="loggedInUserInfo" [crossreferencestandardType]="crossreferencestandardType" [crossreferencestandardNumber]="crossreferencestandardNumber" [crossreferenceparagraphNumber]="crossreferenceparagraphNumber" [crossReferencedContentID]="crossreferencedParaID" [NormalXbrlContent]="NormalXbrlContent" [SECXbrlContent]="SECXbrlContent" [HasXBRL]="HasXBRL" [HasSecXBRL]="HasSecXBRL" [TaxonomyUrl]="taxonomyUrl" [backTo]="backTo" [elementName]="elementName" [reference]="reference" [referenceOther]="referenceOther" [formattedXBRLFlag]="formattedXBRLFlag" [topic]="xbrlTopic" [subtopic]="xbrlSubtopic"></app-xbrl-content>
  </div>
</div>

<div *ngIf="!IsContentPage">
  <app-othersource-content-viewer [content]="otherSourceContent" [title]="otherSourceTitle" [IsGlossary]="glossaryTerm"></app-othersource-content-viewer>
</div>
